module.exports = __webpack_public_path__ + "img/daichao1.c6703c2b.png";